import CalendarEventPeekCallout from './CalendarEventPeekCallout';
import * as styles from './styles.scss';
import type { CalendarViewBaseProps, CalendarViewType } from '../schema';
import { observer } from 'mobx-react-lite';
import { DayGridView } from 'owa-day-grid';
import * as React from 'react';
import ExpandableDatePicker from './ExpandableDatePicker';
import useDayViewViewState from '../hooks/useDayViewViewState';
import type { PerformanceDatapoint } from 'owa-analytics';

export interface DayViewProps extends CalendarViewBaseProps {
    scenarioId: string;
    selectedDate: Date;
    onDateUpdated: (date: Date) => void;
    numDaysInDayView: number | undefined;
    selectedViewType: CalendarViewType;
    assetPerfDatapoint: PerformanceDatapoint;
}

export default observer(function DayView(props: DayViewProps) {
    const {
        ref,
        targetSelector,
        calendarEventInteractionCallback,
        onSelectDate,
        onGridClick,
        onGridDoubleClick,
        handleEditOnItemDrop,
        preventAssetDrag,
    } = useDayViewViewState(props);

    return (
        <div className={styles.dayContainer} ref={ref}>
            <ExpandableDatePicker
                selectedDate={props.selectedDate}
                onSelectDate={onSelectDate}
                numDaysInDayView={props.numDaysInDayView}
                viewType={props.selectedViewType}
                showNavigation={true}
                // in day view navigated date and selected date are the same so onSelectToday is same function as onSelectDate
                onSelectToday={onSelectDate}
            />
            <div className={styles.dayGridViewWrapper}>
                <DayGridView
                    scenario={props.scenarioId}
                    calendarEventInteractionCallback={calendarEventInteractionCallback}
                    onGridClick={onGridClick}
                    onGridDoubleClick={onGridDoubleClick}
                    onGridMouseDown={preventAssetDrag}
                    handleEditOnItemDrop={handleEditOnItemDrop}
                    numDaysInDayView={props.numDaysInDayView}
                    highlightedEventId={props.selectedItemId}
                    greyOutUnselectedItems={false}
                    perfDatapoint={props.assetPerfDatapoint}
                />
            </div>
            <CalendarEventPeekCallout
                target={targetSelector}
                onDismissed={props.onEventsPeekCalloutDismissed}
            />
        </div>
    );
});
